import React, { useState } from 'react';
import { Input, Button, Checkbox, message } from 'antd';
import { useDispatch } from "react-redux";
import { login, validate } from "../store/authSlice";
import { useNavigate } from "react-router-dom";
const DEMO_USER = { email: 'admin@kidodom.com', password: 'admin123', name: 'Admin', role: 'Superuser' };

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

const handleLogin = async () => {
  setError("");

  if (!email.trim() || !password.trim()) {
    setError("Please enter your email and password.");
    return;
  }

  setLoading(true);

  const res = await dispatch(login({ email, password }));

  if (res.meta.requestStatus === "fulfilled") {
    dispatch(validate());
    message.success("Login successful");
    navigate("/dashboard");
  } else {
    const payload = res.payload;
    const msg =
      payload?.error ||
      payload?.message ||
      (typeof payload === "string" ? payload : null) ||
      "Invalid credentials. Please try again.";
    setError(msg);
  }

  setLoading(false);
};

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #2d2255 0%, #1a1540 60%, #0f6e56 100%)',
    }}>
      {/* Decorative blobs */}
      <div style={{ position:'fixed', top:'-80px', right:'-80px', width:320, height:320, borderRadius:'50%', background:'rgba(83,74,183,0.18)', pointerEvents:'none' }} />
      <div style={{ position:'fixed', bottom:'-60px', left:'-60px', width:240, height:240, borderRadius:'50%', background:'rgba(29,158,117,0.15)', pointerEvents:'none' }} />

      <div style={{
        background: '#fff', borderRadius: 20, padding: '48px 44px', width: 420,
        boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
      }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom: 36 }}>
          <img src="/icon.png" alt="Kidodom" style={{ width: 72, height: 72, borderRadius: 18, objectFit: 'contain', marginBottom: 12 }} />
          <div style={{ fontSize: 22, fontWeight: 700, color: '#2d2255', letterSpacing: '-0.5px' }}>Kidodom</div>
          <div style={{ fontSize: 12, color: '#888', letterSpacing: '2px', textTransform: 'uppercase', marginTop: 2 }}>Admin Portal</div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#444', letterSpacing: '0.4px', display: 'block', marginBottom: 6 }}>EMAIL ADDRESS</label>
          <Input
            size="large"
            placeholder="admin@kidodom.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onPressEnter={handleLogin}
            style={{ borderRadius: 10, fontSize: 14 }}
          />
        </div>

        <div style={{ marginBottom: 8 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#444', letterSpacing: '0.4px', display: 'block', marginBottom: 6 }}>PASSWORD</label>
          <Input.Password
            size="large"
            placeholder="••••••••"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onPressEnter={handleLogin}
            style={{ borderRadius: 10, fontSize: 14 }}
          />
        </div>

        {error && (
          <div style={{ background: '#fcebeb', color: '#a32d2d', fontSize: 13, padding: '8px 12px', borderRadius: 8, marginBottom: 12 }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <Checkbox checked={remember} onChange={e => setRemember(e.target.checked)}>
            <span style={{ fontSize: 13, color: '#666' }}>Remember me</span>
          </Checkbox>
          <span style={{ fontSize: 13, color: '#534ab7', cursor: 'pointer' }}>Forgot password?</span>
        </div>

        <Button
          type="primary" size="large" block loading={loading}
          onClick={handleLogin}
          style={{ background: '#534ab7', border: 'none', borderRadius: 10, height: 48, fontSize: 15, fontWeight: 500 }}
        >
          Sign In
        </Button>

      </div>
    </div>
  );
}
